import { create } from "zustand";

export type Plan = "free" | "personal" | "team";

interface PlanState {
  plan: Plan;
  planPeriod: string | null;
  planExpiresAt: string | null;
  isLoading: boolean;
  setPlan: (plan: Plan, period?: string | null, expiresAt?: string | null) => void;
  setLoading: (loading: boolean) => void;
}

export const usePlanStore = create<PlanState>((set) => ({
  plan: "free",
  planPeriod: null,
  planExpiresAt: null,
  isLoading: false,
  setPlan: (plan, period, expiresAt) =>
    set({ plan, planPeriod: period ?? null, planExpiresAt: expiresAt ?? null }),
  setLoading: (isLoading) => set({ isLoading }),
}));
